import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Image from "../../../assets";
import CustomText, { getFontSize, getFontWeight } from "../CustomText";
import RowSection from "../RowSection";
import AddRoundedIcon from "@material-ui/icons/AddRounded";
import RemoveRoundedIcon from "@material-ui/icons/RemoveRounded";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";
import CustomIconButton from "../CustomIconButton";
import Color from "../../../utils/Color";
import Collapse from "@material-ui/core/Collapse";
import CommonQuestions from "../../../containers/pages/OnlineRenewal/components/CommonQuestions";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundImage: `url(${Image.enrolGiroBg})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat:"no-repeat",
  },
  appBar:{
    background:
    "transparent linear-gradient(165deg, #FFC20E 0%, #FEE802 66%, #FEEC01 77%, #FDDB07 86%, #F7941E 100%) 0% 0% no-repeat padding-box",
  },
  leftContainer: {
    background:
    "transparent linear-gradient(143deg, #004880 0%, #0066A7 31%,#007F9C 59%,#008992 80%,#00FFAF 100%) 0% 0% no-repeat padding-box",
    padding: 20,
    paddingLeft:25,
    paddingRight:25,
    marginTop: 62,
    marginBottom:window.innerWidth < 600 ? 100 :false 
  },
  childrenContainer: {
    // [theme.breakpoints.down("md")]: {
    //   minWidth: 400,
    //   maxWidth: 400,
    // },
    // [theme.breakpoints.down("sm")]: {
    //   minWidth: 300,
    //   maxWidth: 300,
    // },
    // minWidth: 450,
    // maxWidth: 450,
    // marginBottom: 50,
  },
  titleContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  titleTextStyle: {
    [theme.breakpoints.only("xs")]: {
      ...getFontSize("xxlarge"),
    },
    ...getFontSize("xxxlarge"),
    ...getFontWeight("800"),
    color: "white",
    textAlign: "center",
  },
  imageStepStyle: {
    [theme.breakpoints.only("md")]: {
      width: 100,
      height: 100,
    },
    [theme.breakpoints.only("sm")]: {
      width: 70,
      height: 70,
    },
    width: 140,
    height: 140,
  },
  connectorImageContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  connectorImageStyle: {
    [theme.breakpoints.only("xs")]: {
      width: 10,
      height: 35,
    },
    [theme.breakpoints.only("sm")]: {
      width: 35,
      height: 10,
    },
    width: 40,
    height: 10,
  },
  stepTextStyle: {
    color: "white",
    textAlign: "center",
  },
  iconButtonStyle: {
    marginRight: 0,
    padding: 0,
    color: Color.primaryColor,
  },
  TNCContainer: {
    marginTop: 10,
  },
  TNCTextStyle: {
    color: "white",
  },
  helpContainer: {
    marginTop: 30,
  },
  highLightedTextStyle: {
    color: "white",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  customerCareImageStyle: {
    width: 40,
    height: 40,
  },
  customerCareTextStyle: {
    color: "white",
    textAlign: "center",
    lineHeight: 1.4,
  },
  renewNowTextStyle: {
    ...getFontSize("xxxlarge"),
    ...getFontWeight("800"),
    textAlign: "left",
  },
}));

const CustomBoardSelectEnrolment = ({ children, height, width }) => {
  const classes = useStyles();
  const [openCommonQuestion, setOpenCommonQuestion] = React.useState(false);
  const [openQ1, setOpenQ1] = React.useState(false);
  const [openQ2, setOpenQ2] = React.useState(false);
  const [openQ3, setOpenQ3] = React.useState(false);
  const [openQ4, setOpenQ4] = React.useState(false);
  const [openQ5, setOpenQ5] = React.useState(false);
  const [openQ6, setOpenQ6] = React.useState(false);

  const theme = useTheme();
  const matchesXS = useMediaQuery(theme.breakpoints.only("xs"));
  const matchesSM = useMediaQuery(theme.breakpoints.only("sm"));
  const matchesMD = useMediaQuery(theme.breakpoints.only("md"));

  const onClickCommonQuestion = () => {
    setOpenCommonQuestion(!openCommonQuestion);
  };

  const onClickQ1 = () => {
    setOpenQ1(!openQ1);
  };

  const onClickQ2 = () => {
    setOpenQ2(!openQ2);
  };

  const onClickQ3 = () => {
    setOpenQ3(!openQ3);
  };

  const onClickQ4 = () => {
    setOpenQ4(!openQ4);
  };

  const onClickQ5 = () => {
    setOpenQ5(!openQ5);
  };

  const onClickQ6 = () => {
    setOpenQ6(!openQ6);
  };

  const onClickHereViewDetails = () => {
    window.open("https://www.etiqa.com.sg/terms-conditions-renewal/");
  };

  const onClickOnlineAccount = () => {
    window.open(process.env.REACT_APP_LOGIN_BASE_URL);
  };

  const onClickGiroLink = () => {
    window.open(
      "https://www.etiqa.com.sg/wp-content/uploads/policy_documents_and_forms/others/Business-Reply-Envelope.pdf"
    );
  };

  return (
    <div className={classes.root}>
      {window.innerWidth > 600 ? (
        <Grid container>
        <AppBar position="fixed" className={classes.appBar}  >
              <Toolbar className={classes.toolbarStyle} style={{justifyContent:"space-between",
              //alignItems: "center",
              display: "flex-start",
              flexDirection: "row",}}  >
                <img src={Image.directClientEtiqaLogo} style={{width:154,height:56}}/>
                <CustomText style={{marginLeft:"-8.5em",color:"#231F20",fontSize:"18px"}}>Enrol GIRO</CustomText>
                <span></span>
              </Toolbar>
              
            
            </AppBar>
         {/*Right*/}
         <Grid
            item
            xs={12}
            sm={12}
            style={{
              height: height,
              justifyContent: "center",
              alignItems: "center",
              display: "flex-start",
              flexDirection: "column",
              marginTop:"8.5em"
            }}
          >
            <Grid container direction={"column"} alignItems={"center"}>
              <Grid item>
                <div className={classes.childrenContainer}>{children}</div>
              </Grid>
            </Grid>
          </Grid>
       
         

         
        </Grid>
      ) : (
        <Grid container>
        
           {/*Right*/}
           <Grid
            item
            xs={12}
            sm={12}
            style={{
              height: height,
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Grid container direction={"column"} alignItems={"center"}>
              <Grid item>
                <div className={classes.childrenContainer}>{children}</div>
              </Grid>
            </Grid>
          </Grid>
      
        </Grid>
      )}
    </div>
  );
};

export default CustomBoardSelectEnrolment;
